export type PromptRecommendationMedia = 'image' | 'video'

export interface ModelPromptRecommendation {
    id: string
    prompt: string
    imageUrl: string
}

export interface ModelPromptRecommendationDefinition {
    id: string
    promptKey: string
    imageUrl: string
}

const promptRecommendationImageUrls: Record<
    PromptRecommendationMedia,
    string[]
> = {
    image: [
        'https://static.weryai.com/image/weryai_04f20f3789477269d37e9e8b80a9d375.png',
        'https://static.weryai.com/image/weryai_261068bedade2d3db72b4b4ae080a075.png',
        'https://static.weryai.com/image/weryai_7621e0b5115a6096395bd90257d27a7e.png',
        'https://static.weryai.com/image/weryai_b50bcb1cc69eb6149dc5fb8406bf9276.png',
        'https://static.weryai.com/image/weryai_a010fde935c1f7ff793614a8c40272db.png',
        'https://static.weryai.com/image/weryai_4cecc385403626ce313e30b3fdd45a8b.png',
        'https://static.weryai.com/image/weryai_ff531ff5bc32947703f323eab3d93de7.png',
        'https://static.weryai.com/image/weryai_ad30545bf19cd1a58d3697362f3a6345.png',
        'https://static.weryai.com/image/weryai_d62444c3681c2a43f8627cb63a486bc9.png',
        'https://static.weryai.com/image/weryai_6153e6d12b3993718bbae683e3098200.png',
        'https://static.weryai.com/image/weryai_67d90713875db8907a0413304feb91fb.png',
        'https://static.weryai.com/image/weryai_4dece51e38e8f7c4fecda377713e807a.png',
        'https://static.weryai.com/image/weryai_ac5377398b4fe214239515871518779e.png',
        'https://static.weryai.com/image/weryai_dd05a515847733c67c70394ecb9a3f8e.png',
        'https://static.weryai.com/image/weryai_adcfe3a2c4f39c5c00fead9913b15a7c.png',
        'https://static.weryai.com/image/weryai_2b08ee279f77c0e77023bfb3118381ef.png',
        'https://static.weryai.com/image/weryai_d198c0abcd61a3a639b98ae419fd884f.png',
        'https://static.weryai.com/image/weryai_ff095c9ee657bb410d6c27a2b04b6e68.png',
    ],
    video: [
        'https://static.weryai.com/image/weryai_8646e1a8488e045bd9d8aa052f6b5db0.png',
        'https://static.weryai.com/image/weryai_9d65f045b2574de11d68fbdcf37b3835.png',
        'https://static.weryai.com/image/weryai_e1719781d607615067c265ca56a903b8.png',
        'https://static.weryai.com/image/weryai_803f0c9604bc5fd96a1ee0bac892a383.png',
        'https://static.weryai.com/image/weryai_622e29ddc15dc9e25ad96e31a7cdaac1.png',
        'https://static.weryai.com/image/weryai_de86a94d920df34fbfc5a2c319775d9f.png',
        'https://static.weryai.com/image/weryai_e0e7dd062d333ebbe7559b0736b8576f.png',
        'https://static.weryai.com/image/weryai_561aafa0f64b12b39df6aa30cdc92324.png',
        'https://static.weryai.com/image/weryai_2d99ca980308fa9747a03831fc0fe2c1.png',
        'https://static.weryai.com/image/weryai_b441f9a01d97fcbffaeada9c79ef8813.png',
        'https://static.weryai.com/image/weryai_24a5ebbae80cfe7e08622dc6b0b92df3.png',
        'https://static.weryai.com/image/weryai_6cc679ad229eec0689dfe92234132bbe.png',
        'https://static.weryai.com/image/weryai_cd1a10a3d55cec96b0c6dceb27f388a4.png',
        'https://static.weryai.com/image/weryai_c1277b5d40211754c8567b63dfc839e5.png',
        'https://static.weryai.com/image/weryai_66308566827e931026cec2acb04ae5c7.png',
        'https://static.weryai.com/image/weryai_c17763cf5f67abe6a09cb0ee4f9dd6f6.png',
        'https://static.weryai.com/image/weryai_8e1e4bb7b2ba63ef668cdbbc08e04504.png',
        'https://static.weryai.com/image/weryai_d90d9a22032b7684a85e047196007cdd.png',
        'https://static.weryai.com/image/weryai_e868b304b602fc9a3d7b08c543869d83.png',
    ],
}

const toItems = (
    media: PromptRecommendationMedia
): ModelPromptRecommendationDefinition[] =>
    promptRecommendationImageUrls[media].map((imageUrl, index) => {
        const id = String(index + 1).padStart(2, '0')
        return {
            id: `${media}-${id}`,
            promptKey: `promptRecommendations.prompts.${media}.${id}`,
            imageUrl,
        }
    })

export const modelPromptRecommendations: Record<
    PromptRecommendationMedia,
    ModelPromptRecommendationDefinition[]
> = {
    image: toItems('image'),
    video: toItems('video'),
}

export const normalizePromptRecommendationMode = (mode: string) => {
    const normalized = mode.trim().toUpperCase()
    if (normalized === 'IMG_TO_IMG') return 'image_to_image'
    if (normalized === 'IMAGE_TO_IMAGE') return 'image_to_image'
    if (normalized === 'IMG_TO_VIDEO') return 'image_to_video'
    if (normalized === 'IMAGE_TO_VIDEO') return 'image_to_video'
    if (normalized === 'TEXT_TO_IMAGE') return 'text_to_image'
    if (normalized === 'TEXT_TO_VIDEO') return 'text_to_video'
    return mode.trim().toLowerCase()
}

/**
 * 图片素材既可用于图生图，也可作为文生图/文生视频的提示词示例。
 * 文生模式点击后只填充文字，不会写入参考图。
 */
export const isPromptRecommendationModeSupported = (
    media: PromptRecommendationMedia,
    mode: string
) => {
    const normalizedMode = normalizePromptRecommendationMode(mode)
    return media === 'image'
        ? normalizedMode === 'image_to_image' ||
              normalizedMode === 'text_to_image'
        : normalizedMode === 'image_to_video' ||
              normalizedMode === 'text_to_video'
}
